import { CarType, ApplicationFeature } from '@digital-dealer/enums';

import IScrollInfo from './types/IScrollInfo';

const mockXprops = (): void => {
  if (!window.xprops) {
    window.xprops = {
      carType: CarType.PersonalCar,
      brands: ['peugeot', 'citroen', 'opel', 'ds', 'fiat', 'fiatProfessional', 'jeep', 'alfaRomeo', 'hongqi', 'voyah', 'navor', 'leapmotor'],
      theme: 'peugeot',
      features: [
        ApplicationFeature.ModelFilters,
        ApplicationFeature.CustomerAddress,
        ApplicationFeature.CustomerBusinessInfo,
        ApplicationFeature.CustomerPhone,
        ApplicationFeature.TradeIn,
        ApplicationFeature.BookTestDrive,
        ApplicationFeature.RequestOffer,
        ApplicationFeature.ShareLink,
        'bankLoan',
        'purchaseOnline',
      ],
      environment: 'development',
      selector: '',
      fixedElementsSelectors: [],
      isWidgetMode: false,
      parentUrl: window.location.href,
      referrer: '',
      privacyPolicyURL: '',
      widgetLocation: {
        domain: window.location.hostname,
        path: window.location.pathname,
        queryString: window.location.search,
      },
      subscribeToScroll: (listener: (scrollInfo: IScrollInfo) => void): Promise<(() => void)> => {
        const handleScroll = (): void => {
          listener({
            x: window.pageXOffset,
            y: window.pageYOffset,
            height: document.getElementById('root')?.clientHeight || 0,
          });
        };

        window.addEventListener('scroll', handleScroll, {
          passive: true,
        });

        return Promise.resolve(
          (): void => {
            window.removeEventListener('scroll', handleScroll);
          },
        );
      },
      autoCalculateSpacers: (): Promise<undefined> => Promise.resolve(undefined),
      getScrollTop: (): Promise<number> => Promise.resolve(document.documentElement.scrollTop),
      scrollTo: async (options: ScrollToOptions): Promise<void> => window.scrollTo({
        ...options,
        behavior: 'smooth',
      }),
      scrollToWidget: async (): Promise<void> => window.scrollTo({
        top: 0,
        behavior: 'smooth',
      }),
      getViewport: (): Promise<any> => Promise.resolve({
        width: window.innerWidth,
        height: window.innerHeight,
      }),
      subscribeToParentHistoryChange: (): null => null,
      pushToParentHistory: (): null => null,
    };
  }
};

export default mockXprops;
